<template>
  <div>
    <!-- <div>{{JSON.stringify(areaModel)}}</div>    -->
    <!-- <div>{{JSON.stringify(info3Model)}}</div> -->
    <customFormCommonArea v-model="areaModel" @refresh="send"></customFormCommonArea>
    <customFormCommonInfo3 v-model="info3Model" @refresh="send"></customFormCommonInfo3>
  </div>
</template>

<script> 
import customFormCommonArea from "@/components/customForm/common/custom-form-common-area/custom-form-common-area.vue"; 
import customFormCommonInfo3 from "@/components/customForm/common/custom-form-common-info3/custom-form-common-info3.vue";
import { mapGetters } from "vuex";
export default {
  // 领域类别： 加盟商
  name: "custom-form-alliance",
  props: { 
    field: {
      type: Object,
      default: { extend: [], properties: [] }
    }
  }, 
  data() {
    return {
      propertyArr: [
        { List: [], TypeId: 0, Value: "授权渠道" },
        { List: [], TypeId: 1, Value: "招募地区" },
        { List: [], TypeId: 2, Value: "服务范围" },
        { List: [], TypeId: 3, Value: "代工品类" },
        { List: [], TypeId: 4, Value: "擅长内容" },
        { List: [], TypeId: 5, Value: "合作渠道" },
        { List: [], TypeId: 6, Value: "放大" }, 
        { List: [], TypeId: 11, Value: "合作客户" }, 
      ], 
      areaModel: { List: [], TypeId: 1, Value: "招募地区"},
      info3Model: { List: [], TypeId: 8 }
    };
  },
  components: { 
    customFormCommonArea,
    customFormCommonInfo3,
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }), 
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let data = this.field.properties; 
      let extend = this.field.extend;
      if (!data) return; 
      data.forEach(c => {
        if (c.TypeId === 1) {
          this.areaModel.List = c.List;
        }
        if (c.TypeId === 8) {
          this.info3Model.List = c.List;
        }
      }); 
      console.log("areaModel: ", this.areaModel); 
      console.log("info3Model: ", this.info3Model);
    },
    send() {
      let model = [];
      let extend = [];
      if (this.areaModel && this.areaModel.List.length) {
        model.push(this.areaModel);
      }
      if (this.info3Model && this.info3Model.List.length) {
        model.push(this.info3Model);
      }   
      this.$emit("change", { extend: extend, properties: model });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
